<script lang="ts">
	import { optimismTokensConfig } from '$lib/tokensConfig';
	import type { TokenSymbol } from '$lib/types/tokens';

	export let showTokenSelector: boolean;
	export let token: TokenSymbol;
</script>

<div class="flex items-center">
	<button
		class="ml-auto cursor-pointer flex items-center gap-2 px-3 py-1 border border-fx-grey-700 bg-fx-grey-900 rounded-3xl hover:bg-fx-grey-700 mb-2"
		on:click={() => {
			showTokenSelector = !showTokenSelector;
		}}
		on:keydown={() => {
			showTokenSelector = !showTokenSelector;
		}}
	>
		<img src={optimismTokensConfig[token].logo} loading="lazy" alt="menu" class="w-7 h-7" />
		<div class="text-fx-grey-200 text-sm font-medium">{token}</div>
		<img src={'down-arrow.png'} loading="lazy" alt="menu" class="w-4" />
	</button>
</div>
